// extracted by mini-css-extract-plugin
export var dropzone = "styles-module__dropzone___unkqT";
export var initialImg = "styles-module__initialImg___mhK3s";
export var dzContent = "styles-module__dzContent___s2Gcv";
export var dzHeader = "styles-module__dzHeader___m_PHh";
export var dzSubText = "styles-module__dzSubText___q8SIt";
export var previewsContainer = "styles-module__previewsContainer____SgI7";